"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeritageHospitality() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return <section data-section-id="223889" id="our-professional-identity" className="bg-background text-foreground relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/technical_grid.png)] bg-repeat mix-blend-multiply" aria-hidden="true" />

      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
          
          <div ref={imgRef} className={`lg:col-span-5 relative h-[60vh] lg:h-[85vh] w-full overflow-hidden rounded-sm transition-all duration-1000 ease-out ${isImgVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="absolute inset-0 w-full h-[120%] -top-[10%] will-change-transform" style={{
            transform: `translateY(${scrollY * 0.15}px)`
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/construction_site_manager.png" alt="Bottom Up Projects Site Management" className="w-full h-full object-cover object-center" />
              <div className="absolute inset-0 bg-primary/10 mix-blend-overlay" />
            </div>
          </div>

          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center space-y-10 lg:pl-8 xl:pl-16 transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <h2 className="font-default text-4xl md:text-5xl lg:text-7xl font-extrabold tracking-wider text-secondary uppercase">
                <span className="block text-primary text-sm font-mono tracking-[0.2em] mb-4">01</span>
                Our Professional Identity
              </h2>
              <div className="w-20 h-[2px] bg-primary" />
            </div>

            <div className="space-y-6 text-foreground/80 font-default text-lg md:text-xl leading-relaxed max-w-2xl">
              <p>
                Bottom Up Projects is a fully licensed and insured construction 
                firm specialising in high-end commercial and industrial fitouts, 
                refurbishments, and remedial works. We deliver precision-engineered 
                solutions across office, warehouse, and retail environments, 
                ensuring every project meets the highest standards of safety, 
                compliance, and structural integrity.
              </p>
              <p>
                Our experienced team utilises industry-leading project management 
                software to ensure transparent communication and accountable 
                outcomes. We prioritise efficiency and reliability, working 
                collaboratively with clients from initial planning through to 
                final defect management, delivering high-quality spaces that 
                celebrate technical excellence and modern functionality.
              </p>
            </div>

            <div className="pt-8 border-t border-border">
              <Button asChild variant="outline" size="lg" className="rounded-sm border-primary text-primary font-bold uppercase tracking-widest hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                <Link to="https://set-starfish.10web.cloud/core-services/">View Core Services</Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}